var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldDocumentNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.71 17.53c0 2.46-2.01 4.47-4.47 4.47H7.76c-2.46 0-4.47-2.01-4.47-4.47V8.12c0-1.71.96-3.2 2.37-3.95.49-.26 1.1.09 1.1.65 0 1.59 1.3 2.89 2.89 2.89h4.7c1.59 0 2.89-1.3 2.89-2.89 0-.56.6-.91 1.1-.65 1.41.75 2.37 2.24 2.37 3.95v9.41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65 2c-1.04 0-1.89.84-1.89 1.88v.94c0 1.04.84 1.88 1.88 1.88h4.71c1.04 0 1.88-.84 1.88-1.88v-.94C16.24 2.84 15.39 2 14.35 2h-4.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldDocumentNormal);
export default __webpack_public_path__ + "static/media/vuesax-bold-document-normal.49d24a5b7273f6d3af66de795d5de6df.svg";
export { ForwardRef as ReactComponent };